import { NextUpDesktopOnly } from 'NextUp';
import { type StudentDashboardConfig } from 'AdmissionsGuidance';
import { StudyBox } from '../StudyBox';
import { TopMessage } from './TopMessage';

export function MobileCourseware({
    studentDashboardConfig,
}: {
    studentDashboardConfig: StudentDashboardConfig | null;
}) {
    return (
        <div className="block sm:hidden">
            <div className="bg-white p-3 pt-[22px]">
                <TopMessage studentDashboardConfig={studentDashboardConfig} />
            </div>
            <div className="mb-3.5">
                <StudyBox
                    card={false}
                    segmentedControlClassNames={{ base: 'mt-0 pt-5 bg-white', tabList: 'bg-white' }}
                />
            </div>
        </div>
    );
}

export function DesktopCourseware({
    studentDashboardConfig,
}: {
    studentDashboardConfig: StudentDashboardConfig | null;
}) {
    return (
        <div className="hidden flex-col gap-3.5 sm:flex md:gap-7.5">
            <TopMessage studentDashboardConfig={studentDashboardConfig} />
            <NextUpDesktopOnly />
            <StudyBox />
        </div>
    );
}
